import { c as _c } from "react/compiler-runtime";
import { Box, Circle, Separator, Flex, Heading, HStack, Image, ImageProps, List, Stack, Text, VStack } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { MdArrowRightAlt } from 'react-icons/md';
export const HistoryBlock: React.FC = () => {
  const $ = _c(27);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  const t0 = isMobile ? "xl" : "3xl";
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([10]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue([4, 4, 10, 10, 10]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      _light: "linear-gradient({colors.teal.300/50}, transparent, transparent, {colors.teal.300/50})",
      _dark: "linear-gradient({colors.teal.muted}, transparent, transparent, {colors.teal.muted})"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Separator flex="1" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== getBreakpointValue) {
    t5 = getBreakpointValue(["xl", "2xl", "3xl"]);
    $[6] = getBreakpointValue;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <Text color="teal.fg" flexShrink="0" fontSize={t5} fontWeight={700} letterSpacing="wide" textAlign="center" textStyle="heading" textTransform="uppercase">History</Text>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Separator flex="1" />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6) {
    t8 = <HStack align="center" gap={10} justify="center" width="full">{t4}{t6}{t7}</HStack>;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== getBreakpointValue) {
    t9 = getBreakpointValue(["3xl", "4xl", "5xl", "6xl"]);
    $[13] = getBreakpointValue;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <Heading color="red.fg" fontWeight={700} size={t9} textAlign="center">We're over 15 years old. That's like 100 in startup years.</Heading>;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = isMobile ? undefined : "4xl";
  let t12;
  if ($[17] !== t11) {
    t12 = <Flex align="center" direction="column" justify="center" width="full"><Text color="red.fg/75" fontSize={t11} fontWeight={600} textAlign="center">Here's our origin story...</Text></Flex>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <HistoryTimeline />;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t0 || $[21] !== t1 || $[22] !== t10 || $[23] !== t12 || $[24] !== t2 || $[25] !== t8) {
    t14 = <VStack align="center" borderRadius={t0} gap={t1} height="full" justify="stretch" overflow="hidden" boxShadow="inset 0 1px 0 rgba(255, 255, 255, 0.2)" padding={t2} width="full" bgImage={t3}>{t8}{t10}{t12}{t13}</VStack>;
    $[20] = t0;
    $[21] = t1;
    $[22] = t10;
    $[23] = t12;
    $[24] = t2;
    $[25] = t8;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
};
const HistoryTimeline: React.FC = () => {
  const $ = _c(69);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  const t0 = isMobile ? 2 : 10;
  const t1 = isMobile ? "column" : "row";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = require("@public/assets/graphics/about/timeline/timeline-fundable.jpg");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["Startups launches Fundable.com - one of the first equity crowdfunding platforms", "Owlet lists on Fundable for its baby smart sock - first company on platform to later go IPO"];
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t1) {
    t4 = <HistoryTimelineItem direction={t1} imageUrl={t2.default.src} year="2012" description={t3} />;
    $[2] = t1;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = isMobile ? "column" : "row-reverse";
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = require("@public/assets/graphics/about/timeline/timeline-bumble.jpg");
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["Bumble debuts on our platform and grows to 100M+ users", "HotelTonight ignites its growth on our platform and later exits to Airbnb (~$400M)"];
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t5) {
    t8 = <HistoryTimelineItem direction={t5} imageUrl={t6.default.src} year="2013" description={t7} />;
    $[6] = t5;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = isMobile ? "column" : "row";
  let t10;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = require("@public/assets/graphics/about/timeline/timeline-launchrock.jpg");
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = ["Vevo builds its initial audience on our platform and scales to 400M+ monthly users", "Acquired Launchrock.com (Trinity, Venture51, 500 Global)", "Acquired KillerStartups.com"];
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== t9) {
    t12 = <HistoryTimelineItem direction={t9} imageUrl={t10.default.src} year="2014" description={t11} />;
    $[10] = t9;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const t13 = isMobile ? "column" : "row-reverse";
  let t14;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = require("@public/assets/graphics/about/timeline/timeline-clarity-zirtual.jpg");
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  let t15;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = ["Acquired Clarity.fm (Dan Martell, Baseline, Freestyle, Mark Cuban)", "Acquired Zirtual.com (Mayfield, Structure Capital)"];
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  let t16;
  if ($[14] !== t13) {
    t16 = <HistoryTimelineItem direction={t13} imageUrl={t14.default.src} year="2015" description={t15} />;
    $[14] = t13;
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  const t17 = isMobile ? "column" : "row";
  let t18;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = require("@public/assets/graphics/about/timeline/timeline-zana.jpg");
    $[16] = t18;
  } else {
    t18 = $[16];
  }
  let t19;
  if ($[17] !== t17) {
    t19 = <HistoryTimelineItem direction={t17} imageUrl={t18.default.src} year="2016" description="Acquired Zana (spun out of True Ventures) to bring world-class education from top experts from Adobe, LinkedIn, and Wordpress." />;
    $[17] = t17;
    $[18] = t19;
  } else {
    t19 = $[18];
  }
  const t20 = isMobile ? "column" : "row-reverse";
  let t21;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = require("@public/assets/graphics/about/timeline/timeline-arcimoto.jpg");
    $[19] = t21;
  } else {
    t21 = $[19];
  }
  let t22;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = ["Acquired BizPlan.com - Online business planning software", "Arcimoto, the electric vehicle company, IPOs after launching on Fundable in 2013"];
    $[20] = t22;
  } else {
    t22 = $[20];
  }
  let t23;
  if ($[21] !== t20) {
    t23 = <HistoryTimelineItem direction={t20} imageUrl={t21.default.src} year="2017" description={t22} />;
    $[21] = t20;
    $[22] = t23;
  } else {
    t23 = $[22];
  }
  const t24 = isMobile ? "column" : "row";
  let t25;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = require("@public/assets/backgrounds/podcast-hero.png");
    $[23] = t25;
  } else {
    t25 = $[23];
  }
  let t26;
  let t27;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = ["Launches Startup Therapy podcast", "Laird Superfood, after launching on Fundable, goes IPO on the NYSE"];
    t27 = {
      boxShadow: "none"
    };
    $[24] = t26;
    $[25] = t27;
  } else {
    t26 = $[24];
    t27 = $[25];
  }
  let t28;
  if ($[26] !== t24) {
    t28 = <HistoryTimelineItem direction={t24} imageUrl={t25.default.src} year="2018" description={t26} imageProps={t27} />;
    $[26] = t24;
    $[27] = t28;
  } else {
    t28 = $[27];
  }
  const t29 = isMobile ? "column" : "row-reverse";
  let t30;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = require("@public/assets/graphics/about/timeline/timeline-startups-m.jpg");
    $[28] = t30;
  } else {
    t30 = $[28];
  }
  let t31;
  if ($[29] !== t29) {
    t31 = <HistoryTimelineItem description="Startups.co becomes Startups.coM by adding a very expensive consonant" direction={t29} imageUrl={t30.default.src} year="2020" />;
    $[29] = t29;
    $[30] = t31;
  } else {
    t31 = $[30];
  }
  const t32 = isMobile ? "column" : "row";
  let t33;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = require("@public/assets/graphics/about/timeline/timeline-thredup.jpg");
    $[31] = t33;
  } else {
    t33 = $[31];
  }
  let t34;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = ["Launches \"Founder Groups\" product to be held in person globally, a week before COVID is announced.", "ThredUp goes IPO after initial launch on our platform", "Athletic Greens, an early member of our Founder Groups, hits $1B valuation"];
    $[32] = t34;
  } else {
    t34 = $[32];
  }
  let t35;
  if ($[33] !== t32) {
    t35 = <HistoryTimelineItem direction={t32} imageUrl={t33.default.src} year="2021" description={t34} />;
    $[33] = t32;
    $[34] = t35;
  } else {
    t35 = $[34];
  }
  const t36 = isMobile ? "column" : "row-reverse";
  let t37;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = require("@public/assets/graphics/about/timeline/timeline-loop.jpg");
    $[35] = t37;
  } else {
    t37 = $[35];
  }
  let t38;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = ["Sonder reaches $2B valuation after Fundable launch", "Loop Returns hits $1.75B valuation while in Founder Groups"];
    $[36] = t38;
  } else {
    t38 = $[36];
  }
  let t39;
  if ($[37] !== t36) {
    t39 = <HistoryTimelineItem direction={t36} imageUrl={t37.default.src} year="2022" description={t38} />;
    $[37] = t36;
    $[38] = t39;
  } else {
    t39 = $[38];
  }
  const t40 = isMobile ? "column" : "row";
  let t41;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = require("@public/assets/graphics/about/timeline/timeline-instacart.jpg");
    $[39] = t41;
  } else {
    t41 = $[39];
  }
  let t42;
  if ($[40] !== t40) {
    t42 = <HistoryTimelineItem description="Instacart, one of our oldest launches, hits IPO and 10M+ Customers" direction={t40} imageUrl={t41.default.src} year="2023" />;
    $[40] = t40;
    $[41] = t42;
  } else {
    t42 = $[41];
  }
  const t43 = isMobile ? "column" : "row-reverse";
  let t44;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = require("@public/assets/graphics/about/timeline/timeline-zirtual.jpg");
    $[42] = t44;
  } else {
    t44 = $[42];
  }
  let t45;
  if ($[43] !== t43) {
    t45 = <HistoryTimelineItem description="Sold Zirtual.com after it became the largest Virtual Assistant business" direction={t43} imageUrl={t44.default.src} year="2024" />;
    $[43] = t43;
    $[44] = t45;
  } else {
    t45 = $[44];
  }
  const t46 = isMobile ? "column" : "row";
  let t47;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = require("@public/assets/graphics/about/timeline/timeline-youtube.jpg");
    $[45] = t47;
  } else {
    t47 = $[45];
  }
  let t48;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = ["Launches Startups.com YouTube channel", "Sale of KillerStartups after having created over 10,000 startup reviews"];
    $[46] = t48;
  } else {
    t48 = $[46];
  }
  let t49;
  if ($[47] !== t46) {
    t49 = <HistoryTimelineItem direction={t46} imageUrl={t47.default.src} year="2025" description={t48} />;
    $[47] = t46;
    $[48] = t49;
  } else {
    t49 = $[48];
  }
  const t50 = isMobile ? "column" : "row-reverse";
  let t51;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = require("@public/assets/graphics/about/timeline/timeline-clarity-sold.jpg");
    $[49] = t51;
  } else {
    t51 = $[49];
  }
  const t52 = isMobile ? false : true;
  let t53;
  if ($[50] !== t50 || $[51] !== t52) {
    t53 = <HistoryTimelineItem description="Sold Clarity.fm" direction={t50} imageUrl={t51.default.src} showDivider={t52} year="2026" />;
    $[50] = t50;
    $[51] = t52;
    $[52] = t53;
  } else {
    t53 = $[52];
  }
  let t54;
  if ($[53] !== t0 || $[54] !== t12 || $[55] !== t16 || $[56] !== t19 || $[57] !== t23 || $[58] !== t28 || $[59] !== t31 || $[60] !== t35 || $[61] !== t39 || $[62] !== t4 || $[63] !== t42 || $[64] !== t45 || $[65] !== t49 || $[66] !== t53 || $[67] !== t8) {
    t54 = <VStack align="center" gap={0} justify="center" maxWidth="container.lg" padding={t0} width="full">{t4}{t8}{t12}{t16}{t19}{t23}{t28}{t31}{t35}{t39}{t42}{t45}{t49}{t53}</VStack>;
    $[53] = t0;
    $[54] = t12;
    $[55] = t16;
    $[56] = t19;
    $[57] = t23;
    $[58] = t28;
    $[59] = t31;
    $[60] = t35;
    $[61] = t39;
    $[62] = t4;
    $[63] = t42;
    $[64] = t45;
    $[65] = t49;
    $[66] = t53;
    $[67] = t8;
    $[68] = t54;
  } else {
    t54 = $[68];
  }
  return t54;
};
const HistoryTimelineItem: React.FC<{
  imageUrl?: string;
  year: string;
  description: string | string[];
  direction: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  showDivider?: boolean;
  imageProps?: ImageProps;
}> = t0 => {
  const $ = _c(32);
  const {
    imageUrl,
    year,
    description,
    direction,
    showDivider: t1,
    imageProps
  } = t0;
  const showDivider = t1 === undefined ? true : t1;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t2;
  if ($[0] !== getBreakpointValue) {
    t2 = getBreakpointValue([true, true, false, false, false]);
    $[0] = getBreakpointValue;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isMobile = t2;
  const t3 = isMobile ? 0 : 10;
  const t4 = isMobile ? 5 : 10;
  let t5;
  if ($[2] !== imageProps || $[3] !== imageUrl || $[4] !== t4) {
    t5 = <Box height="full" width="full"><Image alt="History Timeline Item" borderRadius="xl" boxShadow="lg" marginY={t4} objectFit="cover" src={imageUrl} {...imageProps} /></Box>;
    $[2] = imageProps;
    $[3] = imageUrl;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isMobile) {
    t6 = !isMobile && <TimelineDivider />;
    $[6] = isMobile;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = isMobile ? "center" : "start";
  const t8 = isMobile ? 5 : 10;
  const t9 = isMobile ? "center" : "start";
  let t10;
  if ($[8] !== t9 || $[9] !== year) {
    t10 = <Text color="teal.fg" fontSize="4xl" opacity={1} textAlign={t9} textStyle="labelXl">{year}</Text>;
    $[8] = t9;
    $[9] = year;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== description) {
    t11 = Array.isArray(description) ? description : description.split("\n");
    $[11] = description;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11) {
    t12 = t11.map(_temp);
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t12) {
    t13 = <List.Root gap={4} width="full">{t12}</List.Root>;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== isMobile || $[18] !== showDivider) {
    t14 = isMobile && <TimelineDivider showDivider={showDivider} />;
    $[17] = isMobile;
    $[18] = showDivider;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t10 || $[21] !== t13 || $[22] !== t14 || $[23] !== t7 || $[24] !== t8) {
    t15 = <VStack align={t7} gap={4} justify="center" marginY={t8} width="full">{t10}{t13}{t14}</VStack>;
    $[20] = t10;
    $[21] = t13;
    $[22] = t14;
    $[23] = t7;
    $[24] = t8;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== direction || $[27] !== t15 || $[28] !== t3 || $[29] !== t5 || $[30] !== t6) {
    t16 = <Stack align="center" direction={direction} gap={t3} justify="center" width="full">{t5}{t6}{t15}</Stack>;
    $[26] = direction;
    $[27] = t15;
    $[28] = t3;
    $[29] = t5;
    $[30] = t6;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
};
const TimelineDivider: React.FC<{
  showDivider?: boolean;
}> = t0 => {
  const $ = _c(9);
  const {
    showDivider: t1
  } = t0;
  const showDivider = t1 === undefined ? true : t1;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  const t2 = showDivider ? "flex" : "none";
  const t3 = isMobile ? "50px" : "100%";
  let t4;
  if ($[0] !== t3) {
    t4 = <Box border="1px dashed" borderColor="teal.fg" height={t3} opacity={0.5} width="1px" />;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Circle bgColor="teal.fg" boxShadow="inset 0 1px 0 rgba(255, 255, 255, 0.5)" size={3} />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = isMobile ? "50px" : "100%";
  let t7;
  if ($[3] !== t6) {
    t7 = <Box border="1px dashed" borderColor="teal.fg" height={t6} opacity={0.5} width="1px" />;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t2 || $[6] !== t4 || $[7] !== t7) {
    t8 = <VStack align="center" alignSelf="stretch" display={t2} gap={2} justify="center">{t4}{t5}{t7}</VStack>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
};
function _temp(item, index) {
  return <HStack key={index} align="start" gap={0} justify="start" width="full"><MdArrowRightAlt color="teal.solid" size={24} /><Text color="red.fg" fontSize="md" fontWeight={500}>{item}</Text></HStack>;
}